<script setup>
// Reusable loading overlay for previews
import InlineSpinner from './InlineSpinner.vue'
const props = defineProps({
  show: { type: Boolean, default: false },
  label: { type: String, default: 'Daten werden geladen' },
  spinnerSize: { type: String, default: 'lg' }
})
</script>

<template>
  <transition name="fade">
    <div v-if="show" class="loading-overlay">
      <div class="list-loading-overlay">
        <div class="spinner-center">
          <InlineSpinner :size="spinnerSize" />
          <div class="loadingDescription">{{ label }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.7);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
  backdrop-filter: blur(2px);
  border-radius: 11px;
}
.list-loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 2500;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: all;
}
.spinner-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.spinner-center .loadingDescription {
  font-weight: 600;
  margin-top: 1.2em;
  font-size: 1.1em;
  color: #222;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
